export default __webpack_public_path__ + "static/media/top3.a9b4942c.svg";